import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { StorageMap } from '@ngx-pwa/local-storage';
import { Subject, Subscription, timer } from 'rxjs';
import { repeatWhen, takeUntil } from 'rxjs/operators';
import { ModalCucsComponent } from 'src/app/modules/private/modules/dashboard/theme/sections/modal-cucs/modal-cucs.component';
import { CustomerRequestsService } from 'src/app/services/customer/customer-requests.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { UserRequestsService } from 'src/app/services/user/user-requests.service';
import { UserStoreService } from 'src/app/services/user/user-store.service';
import { ValueShareService } from 'src/app/services/value-share/value-share.service';
import { ModalRedirectComponent } from '../components/modal-redirect/modal-redirect.component';
import { ModalTimeoutComponent } from '../components/modal-timeout/modal-timeout.component';
import { SessionVerificationService } from 'src/app/services/session/session-verification.service';
import { ConfigurationRequestsService } from 'src/app/services/configuration/configuration-requests.service';

import { DialogModalSurveyService } from 'src/app/services/dialog-modal-survey/dialog-modal-survey.service';
import { ModalPerfilInversionistaComponent } from './modal-perfil-inversionista/modal-perfil-inversionista.component';
import { PerfilamientoService } from 'src/app/services/data/actualizacion-datos/perfilamiento.service';
import { IPerfilInversion, IPerfilInversionUi, IPerfilamientoCache, IPerfilNoPerfilResponse, PERFIL_CASE } from 'src/app/services/data/actualizacion-datos/perfilamiento.model';

const ALERT_TIMEOUT = 840;
const LOGOUT_TIMEOUT = 900;
//
@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit, OnDestroy {

  mostrarActualizar = true;
  errorCode = false;
  isOpenFloatMenuNotificaciones: boolean;
  isOpenHeaderNotificaciones: boolean;
  isOpenMenu: boolean;
  isOpenFloatMenu: boolean;
  isOpenHeader: boolean;
  isOpenCucs: boolean;
  showOverloading: boolean;
  currentTop: number;
  currentTopop: number;
  showConsult: boolean;
  showOperation: boolean;
  showOpTraCuot: boolean = false;
  showConsRendi: boolean = false;
  contador: number = 0;
  token: string;
  fondos: any;
  archivos: any;
  juridico: any;
  notificaciones: any;
  $timeOutStop = new Subject();
  $timeOutStart = new Subject();
  $timeOutI = timer(0, 1000).pipe(
    takeUntil(this.$timeOutStop),
    repeatWhen(() => this.$timeOutStart)
  );
  $refreshToken: Subscription;
  $timeoutSubscribption: Subscription;
  flagVerOperacion: string;
  parametrosList: [];
  esJuridico: boolean = false;
  //
  MAX_ONCUCLIST = 10;
  FOOTER_RUC_SURA = "FONDOS SURA SAF S.A.C. RUC 20510000138";
  //
  constructor(
    public userStore: UserStoreService,
    public globalService: GlobalService,
    private userRequests: UserRequestsService,
    private storageService: StorageService,
    private storageMap: StorageMap,
    private router: Router,
    private customerRequests: CustomerRequestsService,
    private matDialog: MatDialog,
    private cdRef: ChangeDetectorRef,
    public valueShareService: ValueShareService,
    private modalSurveyService: DialogModalSurveyService,
    private sessionVerificationService: SessionVerificationService,
    private configurationRequests: ConfigurationRequestsService,
    private _perfilamientoService: PerfilamientoService

  ) {
    this.fondos = [];
  }

    isLegal(tipoDocumento: string) {
      return tipoDocumento == 'RUC' || tipoDocumento == 'OPJ';
    }

    isLegalAccountType(tipoCuenta: string) {
      const normalizedTipoCuenta = (tipoCuenta || '')
        .replace(/├¡/g, 'i')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-zA-Z]/g, '')
        .toUpperCase();

      return normalizedTipoCuenta === 'JURIDICO' || normalizedTipoCuenta === 'JURDICO';
    }

  ngOnInit() {

    this.getParametriaList(); 
    const tipoDocumento: string | null = this.userStore.documentType;
    const tipoCuenta: string = this.userStore.activeCUC && this.userStore.activeCUC.tipoCuenta ? this.userStore.activeCUC.tipoCuenta : '';
    
    this.esJuridico = this.isLegal(tipoDocumento || '') || this.isLegalAccountType(tipoCuenta);
    if(!this.esJuridico){
       this.getConsultarPerfilServ(false, 0);
        const requestsParams = { cuc: this.userStore.activeCUC.cuc };
        this.configurationRequests.getPersonalInformation(requestsParams).subscribe((data) => {
          if(data && data.datos){
            this.userStore.nombres = data.datos.nombresTitular;
            this.userStore.apellidos = data.datos.apellidoPaternoTitular + ' ' + data.datos.apellidoMaternoTitular;
          }
        });
    }

    this.flagVerOperacion = (this.userStore && this.userStore.activeCUC && this.userStore.activeCUC.flagVerOperacion) ? this.userStore.activeCUC.flagVerOperacion : '';
    if (!this.userStore.adviserData) {
      this.userRequests.getUserAdviser().subscribe();
      //this.userRequests.getUserAdviser().subscribe();
    }

    if (this.userStore.COGNITO_USER && (this.userStore.COGNITO_USER.username.includes('ruc') || this.userStore.COGNITO_USER.username.includes('opj'))) {
      this.juridico = true;
    }
    else {
      this.juridico = false;
    }

    
    this.valueShareService.getFondsDebito(this.userStore.activeCUC.cuc)
      .subscribe((response: any) => {
        const newFonds = response.datos.map(({ id, descripcion }) => ({
          id: id,
          nombre: descripcion
        }))

        this.fondos = newFonds.filter((f: any) => (f.id === '15') || (f.id === '17') || (f.id === '34'));
      })
       

    this.valueShareService.getNotificacions(this.userStore.activeCUC.cuc)
      .subscribe((response: any) => {
        this.notificaciones = response.datos.existeCertificado;

        if (this.notificaciones === 'S') {
          this.contador = 1;
        }
      })
      

    this.storageService.storeLastSession(new Date()).subscribe();
    this.$refreshToken = this.userRequests.refreshToken().subscribe(() => this.$refreshToken.unsubscribe());
    //
    this.$timeoutSubscribption = this.$timeOutI.subscribe((t) => {
      if (t === ALERT_TIMEOUT) {
        this.matDialog.open(ModalTimeoutComponent, {
          height: 'auto',
          width: '700px',
          disableClose: true,
        });
      }

      if (t === LOGOUT_TIMEOUT) {
        this.logout();
        this.globalService.timeoutActive.next(false);
      }
    });

    this.globalService.timeoutActive.subscribe((e) => {
      if (e) {
        this.$timeOutStop.next();
        this.$timeOutStart.next();
      }
    });

    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.storageService.storeLastSession(new Date()).subscribe();
      }
    });
  }

  // PERFILAMIENTO
  dataPerfilApi: IPerfilInversion | null = null;
  dataPerfilUi: IPerfilInversionUi = {} as IPerfilInversionUi;
  isPerfilLoading = true;
  refModalPerfil: MatDialogRef<ModalPerfilInversionistaComponent>;
  readonly perfiCase = PERFIL_CASE;

  private buildPerfilCacheKey(tipoDocumento: string | null, numeroDocumento: string | null): string {
    const documentKey = `${tipoDocumento ?? ''}${numeroDocumento ?? ''}`.trim();
    return documentKey ? `perfilamientoData_${documentKey}` : 'perfilamientoData';
  }
  private buildPerfilCacheKeySecundario(documento: string | null): string {
    const documentKey = `${documento ?? ''}`.trim();
    return documentKey ? `perfilamientoData_${documentKey}` : 'perfilamientoData';
  }

  private setPerfilDataUI(dataPerfilApi: IPerfilInversion, mostrarActualizar: boolean = true) {
    this.dataPerfilApi = dataPerfilApi;
    if(this.mostrarActualizar){
        this.dataPerfilUi = {
          perfilName: this.dataPerfilApi.idperfil_aceptado,
          dateLast: this.dataPerfilApi.fechacreacion,
          validateCase: this.dataPerfilApi.porvencer ? this.perfiCase.POR_VENCER : this.perfiCase.ACTUALIZADO,          
          descripCard: this.dataPerfilApi.porvencer ? 'Tu perfil está cercano a vencer' : '',
          showPerfilname: true,
          showCard: this.dataPerfilApi.porvencer
        };
    }else{
        this.dataPerfilUi = {
          perfilName: this.dataPerfilApi.idperfil_aceptado,
          dateLast: this.dataPerfilApi.fechacreacion,
          validateCase:  this.dataPerfilApi.porvencer ? this.perfiCase.POR_VENCER : this.perfiCase.SIN_PERFIL,          
          descripCard: this.dataPerfilApi.porvencer ? 'El perfil está cercano a vencer. Debe ser modificado por el titular de la cuenta.' : 'Debe ser modificado por el titular de la cuenta.',
          showPerfilname: true,
          showCard: true
        };
    }
    this.isPerfilLoading = false;
  }

  private setPerfilSinPerfilUI(noPerfilResponse?: IPerfilNoPerfilResponse, mostrarActualizar: boolean = true) {
    this.dataPerfilUi = {
      perfilName: this.dataPerfilApi?.idperfil_aceptado ?? '',
      dateLast: this.dataPerfilApi?.fechacreacion ?? new Date(),
      validateCase: this.perfiCase.SIN_PERFIL,
      descripCard: ( mostrarActualizar ? 'Tu perfil se encuentra desactualizado' : 'El perfil está desactualizado y debe ser calculado por el titular de la cuenta.'),
      showPerfilname: false,
      showCard: true
    };
    this.isPerfilLoading = false;
  }

  private setPerfilErrorPerfilUI() {
    this.errorCode = true;
    this.dataPerfilUi = {
      perfilName: '',
      dateLast: new Date(),
      validateCase: this.perfiCase.SIN_PERFIL,
      descripCard: 'En estos momentos no se encuentra disponible',
      showPerfilname: false,
      showCard: true
    };
    this.isPerfilLoading = false;
  }

  private isNoPerfilResponse(value: any): value is IPerfilNoPerfilResponse {
    return (
      value &&
      value.status === 400 &&
      value.code === 'GET_PERFILES' &&
      Array.isArray(value.message)
    );
  }


  private isNoPerfilFaultResponse(value: any): value is IPerfilNoPerfilResponse {
    return (
      value &&
      (value.status === 0  || value.status === 500) 
    );
  }

  private useCachedPerfilOrFallback(cacheKey: string) {
    this.storageService.getPerfilamientoData<IPerfilamientoCache | null>(cacheKey).subscribe({
      next: (cachedPerfil) => {
        if (cachedPerfil) {
          if (this.isNoPerfilResponse(cachedPerfil)) {
            this.dataPerfilApi = {} as IPerfilInversion;
            this.setPerfilSinPerfilUI(cachedPerfil, this.mostrarActualizar);
          } else {
            this.setPerfilDataUI(cachedPerfil, this.mostrarActualizar);
          }
        } else {
          this.setPerfilSinPerfilUI(undefined, this.mostrarActualizar);
        }
      },
      error: () => this.setPerfilSinPerfilUI()
    });
  }

  private consultarPerfilDesdeApi(tipoDocumento: string | null, cacheKey: string, retryCount: number) {
    this._perfilamientoService.getConsultarPerfil(tipoDocumento).subscribe({
      next: resp => {
        if (resp?.response && resp.data) {
          this.dataPerfilApi = resp.data;
          if(this.dataPerfilApi.idperfil_aceptado == "AGRESIVO"){
            this.dataPerfilApi.idperfil_aceptado = "DINÁMICO";
          }
          //this.dataPerfilApi.porvencer = true;
          this.storageService.storePerfilamientoData(this.dataPerfilApi, cacheKey).subscribe();
          this.setPerfilDataUI(this.dataPerfilApi, this.mostrarActualizar);
        } else if ((resp as any).status === 0 && retryCount < 2) {
          this.getConsultarPerfilServ(false, retryCount + 1);
        }else if(this.isNoPerfilResponse(resp as any)){
          console.warn('No existe perfil vigente, guardando estado en cache.');
           this.dataPerfilApi = {} as IPerfilInversion;
          this.storageService.storePerfilamientoData((resp as any), cacheKey).subscribe();
          this.setPerfilSinPerfilUI((resp as any), this.mostrarActualizar);
        }else if(this.isNoPerfilFaultResponse(resp as any)){
          console.warn('Error de comunicación con el servicio de perfilamiento, usando cache o fallback.');
          this.setPerfilErrorPerfilUI();
        } 
        else {
          this.useCachedPerfilOrFallback(cacheKey);
        }
      },
      error: (error: any) => {
        const payload = error?.error ?? error;
        const payload2 = error;
        if (this.isNoPerfilResponse(payload)) {
          this.dataPerfilApi = {} as IPerfilInversion;
          this.storageService.storePerfilamientoData(payload, cacheKey).subscribe();
          this.setPerfilSinPerfilUI(payload, this.mostrarActualizar);
          return;
        }else if(this.isNoPerfilFaultResponse(payload2)){
          this.setPerfilErrorPerfilUI();
          return;
        }
        this.setPerfilErrorPerfilUI();
        this.useCachedPerfilOrFallback(cacheKey);
      }
    });
  }


  getConsultarPerfilServ(forceRefresh: boolean = false, retryCount: number = 0) {
    this.isPerfilLoading = true;
    this.mostrarActualizar = this.userStore.activeCUC.tipoMancomuno === undefined
      || this.userStore.activeCUC.tipoMancomuno === null || this.userStore.activeCUC.tipoMancomuno === 'P' ? true : false;
    this.dataPerfilUi = {} as IPerfilInversionUi;
    //const numeroDocumento: string | null = this.mostrarActualizar ? localStorage.getItem('numdoc') : this.userStore.activeCUC.docTitular;
    //const tipoDocumento: string | null = this.mostrarActualizar ? localStorage.getItem('tipdoc') : this.userStore.activeCUC.tipoDocTitular;
    const cacheKey: string = this.buildPerfilCacheKey(this.userStore.activeCUC.cuc, this.userStore.activeCUC.cuc);
    
    

    if (!forceRefresh) {
      this.storageService.getPerfilamientoData<IPerfilamientoCache | null>(cacheKey).subscribe({
        next: (cachedPerfil) => {
          if (cachedPerfil) {
            if (this.isNoPerfilResponse(cachedPerfil)) {
              this.dataPerfilApi = {} as IPerfilInversion;
              this.setPerfilSinPerfilUI(cachedPerfil, this.mostrarActualizar);
              return;
            }
            this.setPerfilDataUI(cachedPerfil, this.mostrarActualizar);
            return;
          }
          this.consultarPerfilDesdeApi(this.userStore.activeCUC.cuc, cacheKey, retryCount);
        },
        error: () => this.consultarPerfilDesdeApi(this.userStore.activeCUC.cuc, cacheKey, retryCount)
      });
      return;
    }

    this.consultarPerfilDesdeApi(this.userStore.activeCUC.cuc, cacheKey, retryCount);

   
  }

  showModalPerfilamiento() {
    document.body.style.overflowY = "hidden";
    this.refModalPerfil = this.matDialog.open(ModalPerfilInversionistaComponent, {
      panelClass: ['dialog_full_perfil'],
      disableClose: true,
      autoFocus: false,
      hasBackdrop: false,
      // data: datos,
    })
    this.refModalPerfil.afterClosed().subscribe((resp: boolean) => {
      document.body.style.overflowY = "visible";
      if(resp) this.getConsultarPerfilServ(true, 0);
    });
  }
  // END PERFILAMIENTO

  ngAfterViewChecked() {
    this.isLoading()
    this.cdRef.detectChanges();
  }

  isLoading() {
    return this.globalService.activeLoading;
  }

  ngOnDestroy() {
    this.$timeoutSubscribption.unsubscribe();
    if(this.refModalPerfil) this.refModalPerfil.close();
  }

  logout() {
    /**this.userRequests.saveUserSessionTime().subscribe(() => {*/
    this.storageMap.clear().subscribe(() => {
      this.userRequests.resetCognito().subscribe(() => {
        this.userRequests.resetCognito();
        this.userRequests.resetUserData();
        localStorage.clear();
        this.modalSurveyService.setModalShown(false);
        localStorage.setItem('isModalShown', JSON.stringify(false));
        localStorage.removeItem('userParametria');
        this.sessionVerificationService.stopSessionVerification();
        this.router.navigate(['/login']).then(() => this.globalService.hideLoading());
      });
    });
    /**}); */
  }

  closeFloat() {
    this.isOpenHeader = false;
    this.isOpenMenu = false;
    this.isOpenHeaderNotificaciones = false;
  }

  showCuc() {
    if (this.userStore.userCUC.length > 10) {
      this.matDialog.open(ModalCucsComponent, {
        width: '320px',
        height: '520px',
        panelClass: window.innerWidth < 800 ? 'full-screen-modal' : '',
        data: {
          isFull: window.innerWidth < 800,
        },
      });
    } else {
      this.isOpenCucs = !this.isOpenCucs;
    }
  }

  selectCUC(CUC) {
    this.isOpenCucs = false;
    this.globalService.showLoading();
    this.userRequests.changeCUC(CUC);
  }

  doRedirect() {
    const CUC = this.userStore.activeCUC.cuc;
    //
    this.showOverloading = true;
    this.customerRequests.getToken4OldWeb(CUC).subscribe(
      (apiResponse: { datos: { jtoken: string } }) => {
        this.token = apiResponse.datos.jtoken;
        const oldWindow = window.open(this.globalService.globalEnvironments.oldVersion + '?jtoken=' + this.token, '_new');
        setTimeout(() => {
          if (!oldWindow || oldWindow.closed || typeof oldWindow.closed == 'undefined') this.matDialog.open(ModalRedirectComponent);
          this.showOverloading = false;
        }, 500);
      },
      () => {
        this.showOverloading = false;
      }
    );
  }

  printUsersRelatedCUC(users: { nomCompleto: string }[]) {
    return (
      'Mancomunada con ' +
      users
        .map((x) => x.nomCompleto.toLowerCase())
        .join()
        .replace(',', ' ')
    );
  }

  showMenu(ev, pixeles) {
    this.currentTop = ev.target.getBoundingClientRect().top - pixeles;
  }

  showMenuop(ev) {
    if (this.flagVerOperacion === 'S') {
      this.currentTopop = ev.target.getBoundingClientRect().top - 300;
    } else {
      this.currentTopop = ev.target.getBoundingClientRect().top - 210;
    }

  }

  redirectHome() {
    this.router.navigate(['/perfil/dashboard']);
  }

  config() {
    const params = `?proceso=datos`;
    this.configurationRequests.getParametria(params).subscribe({
      next: (data) => {
        console.log('[CONFIG] Parametría recibida:', data);
        if (data.resultado.codigo === 0 && data.datos) {
          localStorage.setItem('userParametria', JSON.stringify(data.datos));
        } else {
          console.warn('[CONFIG] Parametría no válida:', data);
        }

        this.router.navigate(['/perfil/configuracion']);
      },
      error: (err) => {
        console.error('[CONFIG] Error al obtener parametría:', err);
        // Aún así navega para evitar que la app se congele
        this.router.navigate(['/perfil/configuracion']);
      }
    }); 
  }

  descargar() {

    this.valueShareService.getNotificacionsDescargar(this.userStore.activeCUC.cuc)
      .subscribe((response: any) => {

        this.archivos = response.datos.file;
        var numeroArchivo = 0;
        this.archivos.forEach(element => {
          numeroArchivo++;
          this.downloadPDF1(element, "certificado_" + numeroArchivo);
        });

      })
  }

  downloadPDF1(pdf: string, nombre: string) {
    const blobData = this.convertBase64ToBlobData(pdf);
    const filename = nombre + ".pdf";
    const contentType = "pdf";
    // chrome
    const blob = new Blob([blobData], { type: contentType });
    const url = window.URL.createObjectURL(blob);
    // window.open(url);
    let intViewportWidth = window.innerWidth;
    //if(intViewportWidth <992){
    //window.open(url,'_blank');  
    //}else{
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
    //}


  }

  convertBase64ToBlobData(base64Data: string, contentType: string = 'image/png', sliceSize = 512) {
    const byteCharacters = atob(base64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  logRendimientos(opcion: string){
   let requestsParams = {
      CUC: this.userStore.activeCUC.cuc,
      segmento: this.userStore.activeCUC.segmento,      
      opcion: opcion,
    };
    this.userRequests.setLogRendimientosUser(requestsParams).subscribe((response: any) => {    
      console.log(response);
      
    })
  }

  getParametriaList(){
    const params = `?proceso=datos`;

     if(localStorage.getItem('userParametria')){
      this.configurationRequests.setUserParametria(JSON.parse(localStorage.getItem('userParametria')));
    }else{

    this.configurationRequests.getParametria(params).subscribe((data) => {
     console.log(data);
      if(data.resultado.codigo == 0 && data.datos != undefined){
       this.parametrosList = data.datos;
       this.configurationRequests.setUserParametria(this.parametrosList);
       localStorage.setItem('userParametria', JSON.stringify(this.parametrosList));
       
     }

    });
    }
 }
}
